
import Vue from "vue";
import { Component, Inject, Prop } from "vue-property-decorator";
import draggable from "vuedraggable";
import { ElementStudioContext } from "@/components/ElementStudio/ElementStudioTabsAndPanels.vue";
import Accordion from "@/components/UI/Accordion.vue";
import Dropdown from "@/components/Reusable/Dropdown/Dropdown.vue";
import CodeInput from "@/components/Reusable/CustomInputs/CodeInput/CodeInput.vue";
import DropdownInput from "@/components/Reusable/CustomInputs/DropdownInput.vue";
import Repeater from "@/components/Reusable/CustomInputs/Repeater/Repeater.vue";
import InlineRepeater from "@/components/Reusable/CustomInputs/InlineRepeater.vue";
import { SpacingBarDescription } from "@/types/elements";
import TextInput from "@/components/Reusable/CustomInputs/TextInput.vue";
import defensiveCopy from "@/util/defensive-copy";
import NiceButton from "@/components/UI/NiceButton.vue";
import ElementStudioSpacingBar from "@/components/ElementStudio/ElementStudioSpacingBar.vue";

@Component({
  components: {
    ElementStudioSpacingBar,
    NiceButton,
    TextInput,
    InlineRepeater,
    Repeater,
    DropdownInput,
    CodeInput,
    Dropdown,
    Accordion,
    draggable
  }
})
export default class ElementStudioSpacingBars extends Vue {
  @Prop({ default: [] })
  value!: SpacingBarDescription[];

  @Inject("context") readonly context!: ElementStudioContext;

  updateSpaceBar(newSpaceBar: SpacingBarDescription, index: number) {
    const spaceBars = defensiveCopy(this.value);

    spaceBars[index] = newSpaceBar;

    this.updateSpaceBars(spaceBars);
  }

  updateSpaceBars(newSpaceBars: SpacingBarDescription[]) {
    this.context.updateElementValue("spacingBars", newSpaceBars);
  }
}
